// @flow
import * as R from "ramda"

const capitalize = (input: any): string =>
  R.is(String, input)
    ? `${input.charAt(0).toLocaleUpperCase()}${input.substr(1).toLocaleLowerCase()}`
    : ""

export default capitalize
